import createRoute        from '@widesk-ui/tools/createRoute';
import ClientRequestModel from '@models/account/ClientRequestModel';

export default createRoute.table('/client_requests', 'account', 'ClientRequestTable', ClientRequestModel.localize('plural'));
